var map = {
	"./dashboard.svg": "f782",
	"./decoration/controls/banner.svg": "69ba",
	"./decoration/controls/category.svg": "af49",
	"./decoration/controls/coupon.svg": "86ea",
	"./decoration/controls/freeShipping.svg": "3a09",
	"./decoration/controls/goods.svg": "b2a7",
	"./decoration/controls/imgNav.svg": "b856",
	"./decoration/controls/searchBar.svg": "3bc6",
	"./decoration/controls/shopNav.svg": "6c3e",
	"./decoration/controls/titleBar.svg": "1a93",
	"./decoration/controls/video.svg": "4506",
	"./decoration/shop-nav/password.svg": "1052",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./link.svg": "18f0",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e81";